import { childElements, getElementById, moveAllChildren } from "../util/Utils";
import { localNavigation } from "./Selectors";
import { setLegacyLabels } from "../tracking/FeatureTracking";
import { eventQBus } from "../types/EventQBus";
import { sheetV1 } from "@otto-ec/otto-components/sheet";
import { HeurekaElementFactory } from "../util/HeurekaElementFactory";
import { registerClickTracker } from "./FilterSheetTracking";
import { deleteEventMergeId } from "../tracking/TrackingUtils";
import { isActive } from "../toggle/Toggle";

export const LOCAL_NAVIGATION = "localNavigation";
const NAVIGATION_DETAIL_SHEET_ID = "heureka-localnavigationsheet";
const FILTER_DETAIL_SHEET_CONTENT_CLASS = "heureka_filterDetailSheet__content";
const FILTER_DETAIL_SHEET_CONTENT_SELECTOR = `.${FILTER_DETAIL_SHEET_CONTENT_CLASS}`;

export default class OcFilterNavigationSheet {
  static readonly factory = HeurekaElementFactory.byId(NAVIGATION_DETAIL_SHEET_ID, OcFilterNavigationSheet);

  /*               */

  constructor(
    readonly sheet: sheetV1 | undefined = getElementById(NAVIGATION_DETAIL_SHEET_ID),
    private readonly sheetContent: HTMLElement | null | undefined = sheet?.querySelector(
      FILTER_DETAIL_SHEET_CONTENT_SELECTOR,
    ),
  ) {
    if (this.sheet) {
      this.sheet.headline = "Kategorien";
    }
  }

  public static pick() {
    return OcFilterNavigationSheet.factory.pick();
  }

  setSheet() {
    const localNavigationChildren = childElements(localNavigation());
    if (this.sheetContent && localNavigationChildren) {
      this.sheetContent.append(...localNavigationChildren);
    }
    return this;
  }

  initializeSheet() {
    if (this.sheet) {
      this.open();
      this.sheet?.addEventListener("oc-sheet-before-close", this.beforeClose);
      this.sheet?.addEventListener("oc-sheet-after-close", this.afterClose);
    }

    if (this.sheetContent) {
      OcFilterNavigationSheet.prepareContent(this.sheetContent);
    }
    return this;
  }

  open() {
    if (this.sheet) {
      this.sheet.open = true;
    }
    return this;
  }

  public deactivate() {
    const source = this.sheetContent;
    const destination = localNavigation();

    if (source) {
      delete source.dataset.filterId;
      delete source.dataset.tsLabels;
    }

    if (this.sheet) {
      this.sheet?.removeEventListener("oc-sheet-before-close", this.beforeClose);
      this.sheet?.removeEventListener("oc-sheet-after-close", this.afterClose);
    }

    moveAllChildren(source, destination);
  }

  /*       */

  private beforeClose = () => {
    this.deactivate();
    eventQBus.emit("ftfind.filterSheet.closedNavigation");
  };

  private afterClose = () => {
    eventQBus.emit("ftfind.filterSheet.closedNavigation");
  };

  private static prepareContent(content: HTMLElement) {
    content.scrollTop = 0;
    content.dataset.filterId = LOCAL_NAVIGATION;

    setLegacyLabels(content, {
      san_FilterFoldoutType: LOCAL_NAVIGATION,
      san_FilterFoldoutActivity: "close",
      san_FacetChangeNothing: "view_selection",
    });
  }

  public addListeners() {
    /*                    */
    this.sheet?.addEventListener("oc-sheet-after-open", () => {
      if (isActive("HEUREKA_2314_LOCAL_NAVI_TRACKING")) {
        eventQBus.emit("ftfind.filterSheet.openedNavigation", { eventMergeId: deleteEventMergeId() });
      } else {
        eventQBus.emit("ftfind.filterSheet.openedNavigation");
      }
    });

    /*                     */
    this.sheet?.addEventListener("oc-sheet-before-close", () => {
      eventQBus.emit("ftfind.filterSheet.closeNavigation");
      this.deactivate();
    });
    this.sheet?.addEventListener("oc-sheet-after-close", () => {
      eventQBus.emit("ftfind.filterSheet.closedNavigation");
    });
    registerClickTracker(this.sheet, {
      capture: true,
      passive: true,
    });
  }
}
